import { Action, createReducer, on } from '@ngrx/store';
import * as storesActions from './stores-actions';
import * as fromStores from './stores-state';
import { StorePagedResponse } from '../../_models/store.interface';

const initialState: fromStores.State = {isLoading: false, data:{count:0,totalCount:0} as StorePagedResponse};
export const reducer = createReducer(
  initialState,
  on(storesActions.LoadingStoresActions, (state) => {
    return {...state, isLoading: true};
  }),
  on(storesActions.CancelRequestStoresActions, (state) => {
    return {...state, isLoading: false};
  }),
  on(storesActions.ErrorStoresActions, (state) => {
    return {...state, isLoading: false};
  }),
   on(storesActions.ListStoresActions, (state, {data}) => {
    return {...state, isLoading: false, data};
  })
);
/* export function productReducer(state: fromProducts.State, action: Action) {
  return reducer(state, action);
} */
